// extracted by mini-css-extract-plugin
module.exports = {"highlighted":"_55873e9"};